import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Register service worker for PWA
import { registerSW } from 'virtual:pwa-register';

// Auto-update service worker
const updateSW = registerSW({
  onNeedRefresh() {
    // Prompt user to refresh for new content
    if (confirm('Nieuwe versie beschikbaar. Wil je de app updaten?')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('App is klaar voor offline gebruik');
  },
  onRegistered(r) {
    // Check for updates every hour
    if (r) {
      setInterval(() => {
        r.update();
      }, 60 * 60 * 1000);
    }
  },
  onRegisterError(error) {
    console.error('Service worker registration error:', error);
  },
});

// Debug: Log before React renders
console.log('[main.tsx] Starting React app...');

try {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  );
  console.log('[main.tsx] React render called');
} catch (error) {
  console.error('[main.tsx] React render error:', error);
  // Show error in DOM as fallback
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = `<pre style="color: red; padding: 20px;">React Error: ${error}</pre>`;
  }
}
